var exports = {
  "banner": "xa15a2ab7--9af05e--banner",
  "logo": "xa15a2ab7--9af05e--logo",
  "logo-redesign": "xa15a2ab7--9af05e--logo-redesign",
  "paragraph": "xa15a2ab7--9af05e--paragraph",
  "rate": "xa15a2ab7--9af05e--rate",
};

module.exports = exports;
